import OrderExtraFilter from '@/components/_common/ExtraFilters/OrderExtraFilter';
import { SaleItemHistoryRequest } from '@/core/domain/sales/SaleItem/SaleItem.types';
import { ExtraFiltersProps } from '@/types/ExtraFiltersProps';
import { Status } from '@/utils/enum/statusEnum';
import { Col, Row, Select } from 'antd';

function DirectSalePartsHistoryExtraFilters({
  queryParams,
  setQueryParams,
}: ExtraFiltersProps<SaleItemHistoryRequest>) {
  const statusOptions = [
    {
      value: Status.open,
      label: 'Aberta',
    },
    {
      value: Status.authorized,
      label: 'Autorizado',
    },
    {
      value: Status.canceled,
      label: 'Cancelado',
    },
  ];

  return (
    <Row gutter={[16, 16]}>
      <Col span={24} md={8} lg={6} xl={4}>
        <OrderExtraFilter
          value={queryParams?.order}
          onChange={(value) =>
            setQueryParams((prev) => ({
              ...prev,
              order: value,
            }))
          }
        />
      </Col>

      <Col span={24} md={12} lg={6}>
        <Select
          allowClear
          style={{ width: '100%' }}
          placeholder="Status"
          options={statusOptions}
          onChange={(value) =>
            setQueryParams((prev) => ({
              ...prev,
              status: value,
            }))
          }
        />
      </Col>
    </Row>
  );
}

export default DirectSalePartsHistoryExtraFilters;
